<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              Новое обращение в службу технической поддержки
            </div>
            <div class="panel-body">
              <div class="form-horizontal">
                <div class="form-group" :class="{'has-error' : errors.has('ticket.subject')}">
                  <label class="col-sm-2 control-label"><b>Тема сообщения*:</b></label>
                  <div class="col-sm-10">
                    <input v-validate="'required|max:768'" class="form-control input-sm"
                           data-vv-as="Тема обращения"
                           :class="{'input': true, 'is-danger': errors.has('ticket.subject')}"
                           name="ticket.subject"
                           type="text" placeholder="Тема сообщения (например Проблема импорта данных)"
                           v-model="ticket.subject"
                           autocomplete="off">
                    <span v-show="errors.has('ticket.subject')" class="text-danger">{{ errors.first('ticket.subject')
                      }}</span>
                  </div>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('ticket.text')}">
                  <label class="col-sm-2 control-label"><b>Описание проблемы*:</b></label>
                  <div class="col-sm-10">
                    <textarea rows="10" v-validate="'required'" class="form-control input-sm"
                              data-vv-as="описание проблемы"
                              :class="{'input': true, 'is-danger': errors.has('ticket.text')}"
                              name="ticket.text"
                              type="ticket.text"
                              placeholder="Описание проблемы или шаги для её воспроизведения"
                              v-model="ticket.text"
                              autocomplete="off"></textarea>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Приложение:</label>
                  <div class="col-sm-10">
                    <form enctype="multipart/form-data">
                      <button onclick="javascript:document.getElementById('file').click()" type="button"
                              class="btn btn-default">
                        <span><i class="mdi mdi-attachment-alt"></i>
                        <span v-if="!file">Приложить файл...</span>
                        <span v-if="file"> {{file.name}}</span>
                      </span>
                      </button>
                      <span v-if="file" @click="file=null" style="cursor: pointer"><i class="mdi mdi-close"></i></span>
                      <span v-if="!file">Допустимые расишрения: .jpg, png, gif, zip, xml, xls(x), doc(x), pdf.</span>
                      <input type="file" style="visibility: hidden" id="file" ref="file"
                             v-on:change="handleFileUpload()"/>
                    </form>
                  </div>
                </div>
              </div>
              <div v-if="sendingTicket" class="col-lg-12">
                <vue-simple-spinner :font-size="20" message="Идёт отправка сообщения."></vue-simple-spinner>
              </div>
              <div v-if="!sendingTicket" class="row xs-pt-15">
                <div class="col-xs-12">
                  <p class="text-center">
                    <button class="btn btn-space btn-success btn-lg" @click="submitData()">Отправить</button>
                    <router-link :to="{name: 'support'}">
                      <button class="btn btn-space btn-danger btn-lg">Отмена
                      </button>
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    data: function () {
      return {
        ticket: {
          subject: null,
          text: null
        },
        file: '',
        sendingTicket: false
      }
    },
    methods: {
      submitData () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let formData = new FormData()
            if (this.file) {
              formData.append('file', this.file)
            }
            formData.append('subject', this.ticket.subject)
            formData.append('text', this.ticket.text)
            let self = this
            this.sendingTicket = true
            axios.post('/api/tickets/', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
              .then((response) => {
                this.sendingTicket = false
                if (response.status === 201) {
                  self.$router.push({name: 'support'})
                  this.$snotify.success('Ваше обращение создано.', 'Успешно!')
                }
              })
              .catch((error) => {
                this.sendingTicket = false
                if (error.response.status >= 400) {
                  this.$snotify.error(error.response.data.detail[0], 'Ошибка!', {timeout: 10000})
                }
              })
          }
        })
      },
      handleFileUpload () {
        this.file = this.$refs.file.files[0]
      },
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/support/TicketAdd.vue